import {
  SET_TAB_MANAGEMENT,
  ACTIVATE_DESACTIVATE_ACCOUNT,
} from "../types/tabManagementTypes";
import { alertSuccess } from "../../utils/feedback";
import axiosInstance from "../../axios/index";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

export const setTabManagement = (
  items,
  totalPages,
  types,
  enterprises,
  creditTiers
) => ({
  type: SET_TAB_MANAGEMENT,
  payload: { items, totalPages, types, enterprises, creditTiers },
});
export const updateUserStatus = (userPublicId, status) => ({
  type: ACTIVATE_DESACTIVATE_ACCOUNT,
  payload: { userPublicId, status },
});

export const fetchTabManagement = (
  page,
  searchText,
  enterprise,
  status,
  type
) => {
  return async (dispatch) => {
    dispatch(requestStarted("tabs"));
    try {
      const res = await axiosInstance.get(
        `/auth/tab_managment?page=${page}&search${
          searchText ? "=" + searchText : ""
        }&type${type !== "" ? "=" + type : ""}&status=${status}&enterprise${
          enterprise && enterprise !== "" ? "=" + enterprise : ""
        }`
      );

      const items = res.data;
      dispatch(
        setTabManagement(
          items?.users,
          items?.total_pages,
          items?.types,
          items?.enterprises,
          items?.credit_tiers
        )
      );
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestUpdateAccountCredit = (
  userPublicId,
  payload,
  page,
  searchText,
  enterprise,
  status,
  type
) => {
  return async (dispatch) => {
    dispatch(requestStarted("tabs"));
    try {
      const res = await axiosInstance.patch(
        `/auth/account_credit/${userPublicId}`,
        payload
      );
      dispatch(requestSucceeded());
      if (res?.data) {
        alertSuccess(res.data);
      }
      dispatch(fetchTabManagement(page, searchText, enterprise, status, type));
      return res?.data;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      throw error;
    }
  };
};

export const requestUpdateCreditTiers = (payload) => {
  return async (dispatch) => {
    dispatch(requestStarted("tabs"));
    try {
      const res = await axiosInstance.patch(`/auth/credit_tiers`, payload);
      dispatch(requestSucceeded());
      if (res?.data) {
        alertSuccess(res.data);
      }
      return res?.data;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      throw error;
    }
  };
};

export const requestUpdateUserStatus = (
  page,
  searchText,
  enterprise,
  status,
  type,
  userPublicId,
  activation,
) => {
  return async (dispatch) => {
    dispatch(requestStarted("tabs"));
    try {
      const res = await axiosInstance.post(
        `/auth/activate_deactivate_account`,
        {
          public_id: userPublicId,
          activated: activation,
        }
      );

      dispatch(requestSucceeded(res.data));
      if (res) {
        alertSuccess(res.data);
      }

      dispatch(updateUserStatus(userPublicId, activation));
      dispatch(fetchTabManagement(page, searchText, enterprise, status, type));
      return res?.data;
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
      throw error;
    }
  };
};
